var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#FFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4800 5108 c-27 -9 -542 -517 -2398 -2372 -1417 -1417 -2369 -2375 -2379 -2396 -72 -153 47 -340 217 -340 93 0 86 -5 585 491 l470 468 1050 3 1050 3 66 26 c96 37 153 73 215 136 64 65 97 119 132 212 23 59 26 85 30 248 l4 182 482 -241 c515 -257 531 -263 623 -237 62 17 143 96 161 155 17 60 17 2168 0 2228 -18 59 -99 138 -161 155 -92 26 -108 20 -624 -238 l-483 -241 0 77 0 78 628 630 c542 543 630 636 640 671 27 95 8 169 -63 239 -70 70 -150 91 -245 63z m-160 -2548 l0 -650 -400 200 -400 200 0 250 0 250 398 199 c218 110 398 200 400 200 1 1 2 -292 2 -649z m-1280 -305 l0 -766 -25 -24 -24 -25 -768 0 -768 0 790 790 c434 435 791 790 792 790 2 0 3 -344 3 -765z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 4148 c-27 -5 -86 -27 -131 -48 -152 -73 -274 -232 -303 -394 -16 -90 -15 -2205 1 -2260 26 -86 136 -166 228 -166 92 0 202 80 228 166 9 31 12 301 12 1113 l0 1072 25 24 24 25 1153 0 1153 0 50 24 c65 30 111 83 131 151 34 119 -20 232 -136 284 -44 20 -58 21 -1215 20 -684 -1 -1191 -5 -1220 -11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImageIcon);
export default __webpack_public_path__ + "static/media/no_image_icon.0b730055e1021bbbddbe3475cee767c0.svg";
export { ForwardRef as ReactComponent };